import React from 'react'
import { KeyboardDateTimePicker } from '@material-ui/pickers'
import { ValidatorComponent } from 'react-material-ui-form-validator'

class ValidatedDatePicker extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      ...rest
    } = this.props
    const { isValid } = this.state

    if (isValid) {
      return <KeyboardDateTimePicker {...rest} />
    }
    return (
      <KeyboardDateTimePicker
        {...rest}
        error={!isValid}
        helperText={(!isValid && this.getErrorMessage()) || helperText}
      />
    )
  }
}

export default ValidatedDatePicker
